import detectPassiveEvents from 'detect-passive-events';

const getEventOptions = () => {
    return detectPassiveEvents.hasSupport
        ? { passive: true }
        : false;
}

export default getEventOptions;
